import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const generateRandom = () => {
  return (Math.random().toString(36) + '000000').substring(2, 8)
}

export default new Vuex.Store({
  state: {
    title: '',
    story: '',
    characters: [],
    correlations: {},
    timeline: [],
    evidences: [],
    others: ''
  },
  mutations: {
    setTitle(state, s){
      state.title = s
    },
    setStory(state, s){
      state.story = s
    },
    setCharacters(state, data){
      data.forEach(ch => { ch.id = ch.id || generateRandom() })
      state.characters = data
    },
    setCorrelation(state, from, to, data){
      console.log(from, to, data)
    },
    setTimeline(state, data){
      data.forEach(row => { row.id = row.id || generateRandom() })
      state.timeline = data
    },
    setEvidences(state, data){
      data.forEach(e => { e.id = e.id || generateRandom() })
      state.evidences = data
    },
    setOthers(state, data){
      state.others = data
    }
  },
  actions: {
    setTitle: ({ commit }, payload) => {
      commit('setTitle', payload)
    },
    setStory: ({ commit }, payload) => {
      commit('setStory', payload)
    },
    setCharacters: ({ commit }, payload) => {
      commit('setCharacters', payload)
    },
    setTimeline: ({ commit }, payload) => {
      commit('setTimeline', payload)
    },
    setEvidences: ({ commit }, payload) => {
      commit('setEvidences', payload)
    },
    setOthers: ({ commit }, payload) => {
      commit('setOthers', payload)
    }
  },
  modules: {
  }
})
